import React from 'react';
import styles from './index.module.scss';

export default function PrintableLabelLink() {
  return (
    <p className={styles.container}>
      If you change your mind about QR code and want to print a label instead,
      please{' '}
      <a
        href="https://tools.usps.com/label-broker.htm"
        rel="noopener noreferrer"
        target="_blank"
        className={styles.link}
      >
        click here
      </a>
    </p>
  );
}
